import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import css from './Modal.module.css';

const Modal = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={css.modalOverlay} onClick={onClose}>
      <div className={css.modalContainer} onClick={e => e.stopPropagation()}>
        <button className={css.closeButton} onClick={onClose} type="button">
          <FormattedMessage id="FieldDateInput.closeDatePicker" />
          <span className={css.closeIcon}>×</span>
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal; 